module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8b65c3c5c1daea486434d91f9e5dba42.png";